export default [
  {
    path: '/app/mod-leads',
    name: 'ModLeads',
    component: () => import('@/views/Admin/Mod_leads/Index.vue'),
    meta: {
      pageTitle: 'Modüller',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_MODULES',
      action: 'read',
    },
  },
  {
    path: '/app/mod-leads/add',
    name: 'ModLeadsAdd',
    component: () => import('@/views/Admin/Mod_leads/Add.vue'),
    meta: {
      pageTitle: 'Modüller',
      breadcrumb: [
        {
          to: '/app/mod-leads',
          text: 'Liste',
        }, {
          text: 'Oluştur',
          active: true,
        },

      ],
      resource: 'ADMIN_MODULES',
      action: 'read',
    },
  },
  {
    path: '/app/mod-leads/edit/:id',
    name: 'ModLeadsEdit',
    component: () => import('@/views/Admin/Mod_leads/Edit.vue'),
    meta: {
      pageTitle: 'Modüller',
      breadcrumb: [
        {
          to: '/app/mod-leads',
          text: 'Liste',
        }, {
          text: 'Güncelle',
          active: true,
        },

      ],
      resource: 'ADMIN_MODULES',
      action: 'read',
    },
  },
]
